import { Pipe, PipeTransform } from '@angular/core';
import { CancellationTerm, CancellationTermType } from '../services/direct.service';

@Pipe({
  standalone: false,
  name: 'cancellationTermsByType',
})
export class CancellationTermsByTypePipe implements PipeTransform {
  transform(terms: CancellationTerm[], type: CancellationTermType): CancellationTerm[] {
    return terms.filter((term) => term.type === type);
  }
}
